import React from 'react';
import { View, ViewStyle } from 'react-native';
import { colorPalette } from '@shared/config/colorsConfig';

interface DividerProps {
    orientation?: 'horizontal' | 'vertical';
    thickness?: 'thin' | 'thick';
    variant?: 'default' | 'light' | 'dark' | 'primary' | 'secondary' | 'success' | 'warning' | 'error';
    spacing?: 'none' | 'small' | 'medium' | 'large';
    style?: ViewStyle;
    className?: string;
}

const spacingValues = {
    none: 0,
    small: 8,
    medium: 16,
    large: 24,
};

const thicknessValues = {
    thin: 1,
    thick: 2,
};

const colorValues = {
    default: colorPalette.gray[300],
    light: colorPalette.gray[200],
    dark: colorPalette.black,
    primary: colorPalette.primary[500],
    secondary: colorPalette.secondary[500],
    success: colorPalette.success[500],
    warning: colorPalette.warning[500],
    error: colorPalette.error[500],
};

const Divider: React.FC<DividerProps> = ({
    orientation = 'horizontal',
    thickness = 'thin',
    variant = 'default',
    spacing = 'medium',
    style,
    className = ''
}) => {
    const isHorizontal = orientation === 'horizontal';
    
    const dividerStyle: ViewStyle = {
        backgroundColor: colorValues[variant],
        ...(isHorizontal ? {
            height: thicknessValues[thickness],
            marginVertical: spacingValues[spacing],
        } : {
            width: thicknessValues[thickness],
            marginHorizontal: spacingValues[spacing],
            alignSelf: 'stretch',
        })
    };

    return (
        <View 
            style={[
                isHorizontal ? { width: '100%' } : { height: '100%', justifyContent: 'center' },
                style
            ]} 
            className={className}
        >
            <View style={dividerStyle} />
        </View>
    );
};

export default Divider;
